<template>
	<v-card class="elevation-0 home-page page">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<div class="home-page__wrap">
				<FeaturedPost :post="this.normalizedFeaturedPost" />
			</div>
      <div class="date-wrapper">
        <FilterChipButton
            v-if="chipsList.length"
            :isButtonActive="isButtonActive"
            :chipsList="chipsList"
            :clearFilter="clearFilter"
            @handleChipClick="handleChipClick"
        />
        <div v-if="filterModalIsVisible">
          <FilterModal
              :filterModalIsVisible="filterModalIsVisible"
              :currentModalFilter="currentModalFilter"
              :currentModalLabel="currentModalLabel"
              :selectedChips="selectedChips"
              :filters="filters"
              :dateError="date.error"
              :dateOption="date.option"
              :dateRange="date.selectedRange"
              @closeModal="closeModal"
              @applySelection="applySelection"
              @setItem="setItem"
          />
        </div>
      </div>
			<div
				v-if="canCreatePost && this.filteredPosts.length !== 0"
				:class="{ 'home-page__fake-btn-modal-container': true, '': chipsList.length }"
				@click="toggleCreatePostModal"
			>
				<div>
					<Avatar
						class="mr-4 post-preview-card__avatar"
						:size="40"
						:avatar="profile.user_logo"
					/>
					<span class="home-page__create-post">What’s on your mind?</span>
				</div>

				<Icon type="pencil" :size="24" color="#a0a0a0" />
			</div>

			<Banner v-if="banner && !isLoading" :banner="banner" :mt="12" />
			<div class="d-flex">
				<v-skeleton-loader
					v-if="isLoading"
					v-bind="attrs"
					max-width="555"
					width="100%"
					type="list-item-avatar, list-item-three-line, card-heading, actions"
				></v-skeleton-loader>
				<div v-else style="width: 100%">
					<div v-if="this.filteredPosts.length === 0" class="mt-5">
						<NewsFeedEmpty
							title="Your News Feed is empty at the moment."
							description="Check back later or create a new post."
						/>
					</div>

					<div
						v-else
						v-for="item in filteredPosts"
						:key="item.thread_id"
						class="mb-1"
						style="margin: 0 !important"
					>
						<PostPreview
							class="post-preview"
							:post="item"
							:displayViews="displayViews"
							:displayLikes="displayLikes"
							:enableLikesButton="enableLikesButton"
							:displayCommentsCount="displayCommentsCount"
							:thread_menu_id="+$route.query.thread_menu_id"
              :selectedChips="selectedChips"
							@applySelection="applySelection"
							@tagClicked="handleTagClick"
						/>
					</div>
				</div>
			</div>

			<div
				class="d-flex my-9 justify-center home-page__pagination"
				v-if="!isLoading && posts.length > 0"
			>
				<Pagination
					:page="filters.page"
					:pageCount="+this.pageCount"
					v-on:pageChange="onPageChange"
				/>
			</div>

			<div v-if="isCreatePostModalVisible && canCreatePost">
				<CreatePostModal
					v-on:closeModal="toggleCreatePostModal"
					:show="isCreatePostModalVisible"
					@postCreated="onPostCreated"
				/>
			</div>

			<v-btn
				v-if="isAllowPostCreating"
				v-show="isShowCreatePostButton"
				@click="toggleCreatePostModal"
				bottom
				right
				:class="{ 'add-post-button': true, 'add-post-button-playerOn': currentPodcast }"
				fixed
				fab
			>
				<v-icon>mdi-plus</v-icon>
			</v-btn>

			<ScrollToTopButton />
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import FeaturedPost from '@/components/Post/PostFeaturedPreview'
import PostPreview from '@/components/Post/PostPreview'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty'
import Pagination from '@/components/Pagination.vue'

import { normalizeFeaturedPost } from '@/utils/helpers'
import Avatar from '@/components/Avatar'
import CreatePostModal from '@/components/Modals/CreatePostModal'
import Block from '@/mixins/Block.js'
import Dwh from '@/mixins/Dwh'
import PageBlocked from '@/components/PageBlocked'
import ScrollToTopButton from '@/components/ScrollToTopButton'
import _ from 'lodash'
import FilterChipButton from '@/components/FilterChipButtons.vue'
import FilterModal from '@/components/Modals/FilterModal'
import Filter from '@/mixins/Filter'
import Banner from '@/components/Banner'

export default {
	name: 'HomePage',
	mixins: [Block, Dwh, Filter],
	components: {
		FilterChipButton,
		PostPreview,
		FeaturedPost,
		NewsFeedEmpty,
		Avatar,
		CreatePostModal,
		PageBlocked,
		Pagination,
		ScrollToTopButton,
		FilterModal,
		Banner,
	},

	methods: {
		...mapActions('post', ['fetchPosts', 'getFeaturedPost']),
		...mapActions('settings', ['fetchChapters', 'getAppCoreSettings']),
		...mapActions('advertisement', ['getBanner', 'clearBanner']),
		...mapActions('app', ['setPageTitle']),
		onPostCreated() {
			this.fetchPosts(this.requestQuery)
		},
		handleTagClick(tagId) {
      const isTagFilter = this.chipsList.some(f => f.name === 'tags')
      if(!isTagFilter) return
      this.filters.page = 1
			if (!this.selectedChips.tags) {
				this.$set(this.selectedChips, 'tags', [])
			}
			if (this.selectedChips.tags.includes(tagId)) {
				this.selectedChips.tags = this.selectedChips.tags.filter((id) => id !== tagId)
			} else {
				this.selectedChips.tags.push(tagId)
			}
			this.currentModalFilter = 'tags'
			this.getFilteredItems()
      window.scrollTo(0, 0)
		},
		checkScreenWidth() {
			this.isShowCreatePostButton = window.innerWidth >= 1264
		},

		toggleCreatePostModal() {
			this.isCreatePostModalVisible = !this.isCreatePostModalVisible
		},
	},
	created() {
		if (!this.isBlocked || this.isBlocked === null) {
			this.fetchPosts(this.requestQuery)
			const bannerQuery = {
				places: ['news_feed'],
				place_sub_id: this.$route.query.thread_menu_id,
				page: this.filters.page,
			}
			if (this.selectedChips.chapters && this.selectedChips.chapters.length) {
				bannerQuery.chapter_id = this.selectedChips.chapters
			}
			this.getBanner(bannerQuery)
		}
	},

	computed: {
		...mapGetters('auth', ['profile']),
		...mapGetters('post', ['isLoading', 'posts', 'featuredPost', 'pageCount']),
		...mapGetters('category', ['selectedCategory']),
		...mapGetters('tag', ['tags']),
		...mapGetters('settings', ['appCore']),
		...mapGetters('rss', ['currentPodcast']),
		...mapGetters('advertisement', ['banner']),

		isAllowPostCreating() {
			const category_id = this.$route.query.category_id
			return (
				_.isNumber(category_id) ||
				(!_.isNaN(category_id) && !_.isNaN(parseFloat(category_id)))
			)
		},
		normalizedFeaturedPost() {
			return normalizeFeaturedPost(this.featuredPost)
		},
		redirectBaseUrl() {
			if (!this.appCore) {
				return []
			}
			return this.appCore.appMenuNormalized.baseMenuItems.find(
				(item) => item.route.name === 'threads'
			)
		},
		filteredPosts() {
			return this.posts.filter(
				(post) =>
					post.thread_type !== 4 ||
					(post.thread_type === 4 && post.poll && post.poll.vote) ||
					(post.thread_type === 4 && (!post.poll || !post.poll.vote))
			)
		},
		currentMenuItem() {
			if (this.appCore) {
				const regex = /:\/\/(.+)/
				const currentMenuItem = this.appCore.app_menu.find((item) => {
					const match = item.url.match(regex)
					const result = match ? match[1] : null
					return (
						result === 'threads' &&
						item.params.thread_menu_id === +this.$route.query.thread_menu_id
					)
				})
				return currentMenuItem
			}
			return null
		},
		canCreatePost() {
			if (this.currentMenuItem) {
				return !!this.currentMenuItem.params.allow_posting
			}
			return false
		},
		displayViews() {
			if (this.currentMenuItem) {
				return !!this.currentMenuItem.params.display_views
			}
			return false
		},
		displayLikes() {
			if (this.currentMenuItem) {
				return !!this.currentMenuItem.params.display_likes
			}
			return false
		},
		enableLikesButton() {
			if (this.currentMenuItem) {
				return !!this.currentMenuItem.params.enable_likes_button
			}
			return false
		},
		displayCommentsCount() {
			if (this.currentMenuItem) {
				return !!this.currentMenuItem.params.display_comments_count
			}
			return false
		},
	},

	watch: {
		selectedCategory: {
			handler(val) {
				this.getFeaturedPost(val ?? 1)
			},
		},
		appCore: {
			handler(appCore) {
				if (!this.$route.query.thread_menu_id && appCore) {
					const { route } = this.redirectBaseUrl || {}

					this.$router.push({
						name: route.name,
						query: route.query,
					})
				}
			},
			immediate: true,
		},
		'$route.query.thread_menu_id': function (newValue) {
			this.fetchPosts(this.requestQuery)
			this.clearBanner()
			const bannerQuery = {
				places: ['news_feed'],
				place_sub_id: newValue,
				page: this.filters.page,
			}
			if (this.selectedChips.chapters && this.selectedChips.chapters.length) {
				bannerQuery.chapter_id = this.selectedChips.chapters
			}
			this.getBanner(bannerQuery)
		},
	},
	mounted() {
		window.addEventListener('resize', this.checkScreenWidth)
		this.setPageTitle('News Feed')
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.checkScreenWidth)
		this.setPageTitle('')
	},
	data() {
		return {
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			isShowCreatePostButton: true,
			isCreatePostModalVisible: false,
			pageBlockedName: 'threads',
		}
	},
}
</script>

<style lang="scss">
@media (min-width: 640px) {
	.post-preview {
		padding-left: 1.25rem;
		padding-right: 1.25rem;
	}
}

@media (min-width: 1024px) {
	.post-preview {
		padding-left: 0;
		padding-right: 0;
	}
}

.home-page {
	background: #f1f1f1 !important;

	&__divider {
		border-color: #000 !important;
		mix-blend-mode: normal;
		opacity: 0.1;
	}
	&__fake-btn-modal-container {
		display: flex;
		justify-content: space-between;
		padding: 12px;
		height: 64px;
		border-radius: 8px;
		border: 1px solid #e2e2e2;
		background-color: #ffffff;
	}
	&__create-post {
		font-family: Inter, sans-serif;
		font-weight: 400;
		font-size: 16px;
		line-height: 100%;
		letter-spacing: 0;
		text-align: center;
		color: #9b9b9b;
	}

	&__pagination {
		@media screen and (min-width: 1264px) {
			max-width: 600px;
		}

		.theme--light.v-pagination .v-pagination__item--active {
			color: #fff !important;
			background: var(--accent-color) !important;
			border-radius: 4px;
			height: 30px;
			width: 30px;
		}

		.v-pagination__item {
			font-size: 15px;
			font-family: Inter, sans-serif;
			font-weight: bold;
			text-align: center;
			color: var(--accent-color) !important;
			background: none !important;
			box-shadow: none !important;
			white-space: nowrap;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.v-pagination__navigation {
			background: none !important;
			box-shadow: none !important;
		}
	}

	.post {
		&__search {
			background: white;
			height: 54px;
			border-radius: 10px;
			border: 1px solid rgb(230, 230, 230);
			max-width: 600px;
		}

		&__fake-btn-modal {
			&-container {
				display: flex;
				align-items: center;
				justify-content: space-between;
				height: 54px;
				background: rgb(255, 255, 255);
				border: 1px solid rgb(230, 230, 230);
				border-radius: 10px;
				padding: 20px 15px;
				max-width: 600px;
				cursor: pointer;

				color: rgb(160, 160, 160);
				font-size: 15px;
				font-family: Montserrat, sans-serif;
				font-weight: normal;
				letter-spacing: -0.43px;
			}
		}

		@media screen and (max-width: 1264px) {
			&__search {
				max-width: none;
				width: 100%;
			}
			&__fake-btn-modal-container {
				max-width: none;
				width: 100%;
			}
		}
	}
}

.add-post-button {
	right: 20% !important;

	&-playerOn {
		transform: translateY(-100px);

		@media (max-width: 710px) {
			transform: translateY(-150px);
		}

		@media (max-width: 530px) {
			transform: translateY(-200px);
		}
	}
}

@media screen and (min-width: 1264px) and (max-width: 1600px) {
	.add-post-button {
		right: 13% !important;
	}
}
</style>
